import React, { Component } from 'react';
import { Button, Modal, Icon, Header } from 'semantic-ui-react';
import FormUser from '../FormUser/FormUser';


class ModalUser extends Component {

  render() {
    return (
      <Modal  trigger={ 
      <Button color={this.props.buttonColor} icon > 
      <Icon name={this.props.iconName} />
          {this.props.buttonTriggerTitle}
      </Button>}
    //    dimmer='inverted'
        closeIcon
      >
        <Header icon='user' content={this.props.headerTitle} />
        <Modal.Content scrolling >
          
          <FormUser
            buttonSubmitTitle={this.props.buttonSubmitTitle}
            buttonColor={this.props.buttonColor}
            clienteID={this.props.clienteID}
            onClienteAdded={this.props.onClienteAdded}
            onClienteUpdated={this.props.onClienteUpdated}
            server={this.props.server}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

export default ModalUser;
